module.exports = __webpack_public_path__ + "img/es.0235f49f.png";